import {Container, Col }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import FormContact from '../forms/contact';
import FormWrapper from '../forms/formwrapper';
function PageContact(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                    <MainContent>
                        <Col md={{span: 4, offset: 4}}>
                        <FormWrapper>
                            <FormContact/>
                        </FormWrapper>
                            
                        </Col>                        
                    </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageContact;